import React, { useEffect, useState } from 'react';
import { client } from 'shared';
import JobTemplateOption from './JobTemplateOption';
import { BusinessJobTemplateListDTO } from 'parent-portal/forms/JobTemplateModels';
import { styled } from '@mui/material';
import { OutlinedDropdown, Text } from 'library';
import { useUserContext } from 'UserContext';

export default function JobTemplateListContent({
    address,
    setAddress,
    emptyText,
    selectedJobId,
    setSelectedJobId,
    openJobsOnly = false,
}: {
    address: number | null;
    setAddress: (addressId: number) => void;
    emptyText?: string;
    selectedJobId?: number;
    setSelectedJobId: (jobId?: number) => void;
    openJobsOnly?: boolean;
}) {
    const { user } = useUserContext();
    const [jobTemplates, setJobTemplates] = useState<BusinessJobTemplateListDTO[]>([]);

    useEffect(() => {
        if (!address) return;
        client(`api/job-template/?address=${address}&open_jobs=${openJobsOnly}`).then(setJobTemplates);
    }, [address]);

    function handleAddressChange(value: string) {
        setAddress(parseInt(value));
    }

    return (
        <>
            {user && user.address.length > 0 ? (
                <LocationContainer>
                    <Text variant="body1" bold>
                        Location:
                    </Text>
                    <OutlinedDropdown
                        value={address || ''}
                        fields={user.address
                            .filter((x) => x.can_post_jobs)
                            .map((addr) => {
                                return { key: addr.id.toString(), value: addr.description || '' };
                            })}
                        onChange={(e) => handleAddressChange(e.target.value)}
                    />
                </LocationContainer>
            ) : null}
            <ListContainer>
                {jobTemplates.length > 0 ? (
                    jobTemplates.map((jobTemplate) => (
                        <JobTemplateOption
                            key={jobTemplate.id}
                            jobTemplate={jobTemplate}
                            selectedJobId={selectedJobId}
                            setSelectedJobId={setSelectedJobId}
                        />
                    ))
                ) : (
                    <Text variant="body1">
                        {emptyText ?? "Sorry, we couldn't find any recent jobs to duplicate for this location."}
                    </Text>
                )}
            </ListContainer>
        </>
    );
}

const LocationContainer = styled('div')({
    marginTop: 20,
    display: 'flex',
    flexDirection: 'row',
    gap: 8,
    alignItems: 'center',
});

const ListContainer = styled('div')({
    marginTop: 20,
});
